// Live show/hide for the discovery workspace's conditional ("yellow")
// questions and agenda talking points. Elements tagged
// data-reveal-question / data-reveal-values (JSON array) are shown only
// while the controlling question's select — tagged data-reveal-source —
// holds one of those values. A target whose controlling select is itself
// inside a hidden element stays hidden (e.g. a follow-up to a question the
// section gate hasn't revealed yet).
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.refresh();
  }

  refresh() {
    const sources = {};
    this.element.querySelectorAll("[data-reveal-source]").forEach((el) => {
      const select = el.matches("select") ? el : el.querySelector("select");
      if (select) sources[el.dataset.revealSource] = { value: select.value, element: el };
    });

    const targets = Array.from(this.element.querySelectorAll("[data-reveal-question]"));
    // Two passes so a target hides when its controlling select was hidden by
    // the first pass (chained reveals).
    for (let pass = 0; pass < 2; pass += 1) {
      targets.forEach((el) => {
        const source = sources[el.dataset.revealQuestion];
        const wanted = JSON.parse(el.dataset.revealValues || "[]");
        const visible = !!source &&
          wanted.includes(source.value) &&
          !source.element.classList.contains("d-none") &&
          !source.element.closest(".d-none");
        el.classList.toggle("d-none", !visible);
      });
    }

    // Let the progress badges recount now that visibility changed.
    this.dispatch("refreshed");
  }
}
